import { SahinDataTable } from 'common/components/DataTable/SahinDataTable';
import { EmptyState } from 'common/components/EmptyState';
import { FailedLoad } from 'common/components/FailedLoad/FailedLoad';
import { Loading } from 'common/components/Loading/Loading';
import { SahinButton } from 'common/components/SahinButton/SahinButton';
import { deleteAPI } from 'common/helper/apiHelpers';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { Nullable } from 'common/model/Nullable';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { mutate } from 'swr';
import { ProductForm } from '../Form/ProductForm';
import { productListColumns } from './ProductList.types';

export const COMPONENT_TABLE_PATH = AdminTablePaths.PRODUCT;

export const ProductList = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(15); // Default 15

  const fetchUrl = `${COMPONENT_TABLE_PATH}?page=${currentPage}&per_page=${perPage}&branch=${branchId}`;

  const { data, error, isLoading, totalData, totalPage } = useFetch<Product[]>(
    fetchUrl,
    {
      revalidateOnFocus: false,
    },
  );

  const [selectedItem, setSelectedItem] =
    useState<Nullable<Partial<Product>>>(null);

  const onAdd = () => {
    setSelectedItem({ isActive: true });
  };

  const onEdit = (selected: Product) => {
    setSelectedItem(selected);
  };

  const onDelete = (selected: Product) => {
    deleteAPI(COMPONENT_TABLE_PATH, selected.id)
      .then(() => {
        // Mevcut sayfa fetch edilsin, üst sayfalar sadece cache temizlensin
        const cacheKeys = [];
        for (let i = currentPage + 1; i <= (totalPage || 1); i++) {
          const cacheUrl = `${COMPONENT_TABLE_PATH}?page=${i}&per_page=${perPage}&branch=${branchId}`;
          cacheKeys.push(cacheUrl);
        }

        mutate(fetchUrl);
        cacheKeys.forEach((key) => mutate(key, undefined, false));
      })
      .catch((error) => console.error(error));
  };

  const onCloseModal = () => {
    setSelectedItem(null);
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPerPage(newPageSize);
    setCurrentPage(1); // Sayfa boyutu değiştiğinde ilk sayfaya dön
  };

  if (error) return <FailedLoad />;
  if (isLoading) return <Loading />;

  return (
    <>
      <ProductForm
        open={Boolean(selectedItem)}
        initialData={selectedItem}
        handleClose={onCloseModal}
        currentPage={currentPage}
        perPage={perPage}
      />
      <SahinDataTable
        data={data}
        columns={productListColumns}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
        currentPage={currentPage}
        totalPages={totalPage || 1}
        totalData={totalData || 0}
        onPageChange={handlePageChange}
        pageSize={perPage}
        onPageSizeChange={handlePageSizeChange}
        customEmptyMessage={
          <EmptyState
            title="Henüz Ürün Yok"
            variant="products"
            icon="🍽️"
            iconSize={55}
            action={
              <SahinButton
                variant="contained"
                onClick={onAdd}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 500,
                  backgroundColor: '#2e2e2e',
                  textTransform: 'uppercase',
                }}
              >
                İlk Ürününüzü Ekleyin
              </SahinButton>
            }
          />
        }
      />
    </>
  );
};
